import api from './api';
import type { ConsultationServiceItem, ServiceItem, TeamMemberRecord } from '../types';

export const publicContentService = {
  getServices: async (): Promise<ServiceItem[]> => {
    return api.get('services').json<ServiceItem[]>();
  },

  getConsultationServices: async (): Promise<ConsultationServiceItem[]> => {
    return api.get('consultation-services').json<ConsultationServiceItem[]>();
  },

  getTeam: async (): Promise<TeamMemberRecord[]> => {
    return api.get('team').json<TeamMemberRecord[]>();
  },
};
